'use strict';
var stj = typeof stj !== 'undefined' ? stj : {};

stj.serviceWorkerHandler = {
    enable: function () {
        stj.global.setLocalStorage('useServiceWorker', true);
    },

    disable: function () {
        stj.global.setLocalStorage('useServiceWorker', false);
    },

    isActive: function () {
        return (
            ApplicationProperties.get('useServiceWorker') ||
            stj.global.getLocalStorage('useServiceWorker')
        );
    },

    register: function () {
        /* eslint-disable-next-line compat/compat */
        navigator.serviceWorker
            .register(this.getPath(), this.getConfig())
            .then(this.onRegistrationSuccess)
            .catch(this.onRegistrationError);
    },

    getPath: function () {
        var ASSET_ORIGIN = document.location.origin;
        return (
            ASSET_ORIGIN +
            (ApplicationProperties.get('serviceWorkerPath') ||
                '/reservation/serviceworker.js')
        );
    },

    getConfig: function () {
        return {
            scope: '/',
        };
    },

    onRegistrationSuccess: function () {
        if (typeof newrelic !== 'object') {
            return;
        }

        newrelic.setCustomAttribute('serviceWorkerRegistered', 'registered');

        // eslint-disable-next-line compat/compat
        navigator.serviceWorker.addEventListener('message', function (event) {
            // eslint-disable-next-line no-console
            console.log('serviceworker sent:', event);
        });

        window.dispatchEvent(new Event('serviceworkerregistered'));
    },

    onRegistrationError: function (error) {
        if (typeof newrelic !== 'object') {
            return;
        }
        newrelic.noticeError(
            typeof error === 'string' ? new Error(error) : error
        );
        newrelic.setCustomAttribute('serviceWorkerRegistered', 'error');
    },

    deregister: function () {
        /* eslint-disable-next-line compat/compat */
        navigator.serviceWorker
            .getRegistrations()
            .then(function (registrations) {
                if (!registrations.length) {
                    return;
                }
                for (var registration in registrations) {
                    registrations[registration].unregister();
                }
            });
    },

    sendMessage: function (message) {
        return new Promise(function (resolve, reject) {
            var messageChannel = new MessageChannel();
            messageChannel.port1.onmessage = function (event) {
                if (event.data.error) {
                    reject(event.data.error);
                } else {
                    resolve(event.data);
                }
            };

            // eslint-disable-next-line compat/compat
            if (!navigator.serviceWorker.controller) {
                reject(new Error('service worker not yet in control of page'));
            }

            // eslint-disable-next-line compat/compat
            navigator.serviceWorker.controller.postMessage(message, [
                messageChannel.port2,
            ]);
        });
    },
};

if ('serviceWorker' in navigator) {
    window.addEventListener('load', function () {
        if (!stj.serviceWorkerHandler.isActive()) {
            stj.serviceWorkerHandler.deregister();
        } else {
            stj.serviceWorkerHandler.register();
        }
    });
}
